
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Minus, Plus } from "lucide-react";

interface QuantityPriceInputsProps {
  quantidade: number;
  setQuantidade: (value: number) => void;
  precoUnitario: number;
  setPrecoUnitario: (value: number) => void;
  quantidadeMin?: number;
  quantidadeMax?: number;
}

export const QuantityPriceInputs = ({ 
  quantidade, 
  setQuantidade, 
  precoUnitario, 
  setPrecoUnitario,
  quantidadeMin = 1,
  quantidadeMax,
}: QuantityPriceInputsProps) => {
  const incrementarQuantidade = () => {
    if (!quantidadeMax || quantidade < quantidadeMax) {
      setQuantidade(quantidade + 1);
    }
  };

  const decrementarQuantidade = () => {
    if (quantidade > quantidadeMin) {
      setQuantidade(quantidade - 1);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="grid gap-2">
        <Label htmlFor="quantidade">Quantidade</Label>
        <div className="flex items-center">
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={decrementarQuantidade}
            disabled={quantidade <= quantidadeMin}
            className="h-9 w-9 rounded-r-none"
          >
            <Minus className="h-4 w-4" />
          </Button>
          <Input
            id="quantidade"
            type="number"
            min={quantidadeMin}
            max={quantidadeMax}
            value={quantidade}
            onChange={(e) => {
              const val = Number(e.target.value);
              if (val >= quantidadeMin && (!quantidadeMax || val <= quantidadeMax)) {
                setQuantidade(val);
              }
            }}
            className="rounded-none text-center"
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={incrementarQuantidade}
            disabled={quantidadeMax !== undefined && quantidade >= quantidadeMax}
            className="h-9 w-9 rounded-l-none"
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="preco">Preço Unitário (R$)</Label>
        <Input
          id="preco"
          type="number"
          min="0"
          step="0.01"
          value={precoUnitario}
          onChange={(e) => setPrecoUnitario(Number(e.target.value) || 0)}
        />
      </div>
    </div>
  );
};
